<template>
  <div class="products-listing-breadcrumbs"
       role="navigation"
       aria-label="Categories breadcrumbs">
    <nuxt-link v-for="(breadcrumb, index) in breadcrumbs"
              :key="`breadcrumb${index}`"
              :to="`/categories/${breadcrumb.permalink}`"
              class="products-listing-breadcrumbs__item"
              :class="{ 'products-listing-breadcrumbs__item--active': index === breadcrumbs.length - 1 }">
      {{ breadcrumb.name }}
    </nuxt-link>
  </div>
</template>

<script>
  export default {
    name: 'ProductsListingBreadcrumbs',
    props: {
      breadcrumbs: {
        type: Array,
        default: []
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/variables.scss';

  .products-listing-breadcrumbs {
    text-decoration: none;
    text-transform: capitalize;
    color: $color-gray-light;
    font-family: 'MotivaSans Light';
    font-size: 1.4rem;
    margin: 25px 0 40px;

    &__item {
      display: inline-flex;

      &:after {
        content: '>';
        margin: 0 5px;
      }

      &:last-child {
        &:after {
          content: '';
        }
      }

      &--active {
        text-transform: uppercase;
        text-decoration: underline;
        color: $color-black;
      }
    }

    @media screen and(max-width: $products-filters-mobile-max) {
      margin-bottom: 30px;
    }
  }
</style>
